<div class="hero-section">
  <div class="hero-shell">
    <div class="hero-content">
      <h1 class="hero-title">
        <span class="hero-title-line">Manage Every Customer</span>
        <span class="hero-title-line hero-title-line--second">Relationship in <span class="hero-title-highlight">One Place</span>.</span>
      </h1>

      <p class="hero-description">
        Track leads, deals, and conversations from first contact to closed sale.
        A simple CRM built to help your team follow up faster and never lose a customer.
      </p>

      <div class="hero-buttons">
        <button class="hero-btn hero-btn-primary" type="button" (click)="showRegister = true">Start free trial</button>
        <a class="hero-btn hero-btn-secondary" href="https://calendly.com/tahir-aslam-techcolleagues/meeting-with-tahir-aslam-founder-tech-colleagues?month=2026-07" target="_blank" rel="noopener noreferrer">Book a meeting</a>
      </div>
    </div>

    <div class="hero-visual" aria-hidden="true">
      <div class="contact-card contact-card--main">
        <div class="contact-card-top">
          <div class="contact-avatar">SA</div>
          <div class="contact-info">
            <span class="contact-name">Sara Ahmed</span>
            <span class="contact-company">Golden Green Store</span>
          </div>
          <span class="contact-stage">Deal — Proposal</span>
        </div>
        <div class="contact-card-row">
          <span class="contact-row-icon">✉️</span>
          <span>Sent pricing follow-up — 2h ago</span>
        </div>
        <div class="contact-card-row">
          <span class="contact-row-icon">📞</span>
          <span>Call scheduled — Tomorrow, 11:00 AM</span>
        </div>
      </div>

      <div class="floating-chip floating-chip--lead">
        <span class="floating-chip-icon">🎯</span>
        <span>New lead: Ali Raza</span>
      </div>

      <div class="floating-chip floating-chip--won">
        <span class="floating-chip-icon">✅</span>
        <span>Deal won — $4,200</span>
      </div>
    </div>
  </div>
</div>

<app-register
  *ngIf="showRegister"
  [selectedApps]="crmApp"
  (goBack)="showRegister = false"
></app-register>
